import { BaseEntity } from "yt-ng-framework";


export class RadnoMestoPosloviView extends BaseEntity{
    constructor(){
        super();
    }
    RadnoMesto: string = null;
    Poslovi: string = null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.RadnoMesto = input.RadnoMesto;
        this.Poslovi = input.Poslovi;
        return this; 
    }

    Serialize(input: RadnoMestoPosloviView) {
        return input;
    }
}